import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";

export const NOT_AVAILABLE = "N/A";
export const MAX_EXPORT_DEPTH = 350;
export const CUSTOMER_SUPPORT_URL =
  "https://zc-kb-technology.atlassian.net/servicedesk/customer/user/login?destination=portals";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string) {
  if (!date.length) return NOT_AVAILABLE;
  return format(date, "dd.MM.yyyy HH:mm:ss");
}

export function formatDateForExport(date: string) {
  if (!date.length) return "";
  return format(date, "dd.MM.yyyy HH:mm:ss");
}

export function formatDateForValidity(date: string) {
  if (!date.length) return NOT_AVAILABLE;
  return format(date, "dd.MM.yyyy");
}

export function getProgress(currentPage: number, totalPages?: number) {
  if (!totalPages || totalPages <= 0) {
    throw new Error("Total pages must be greater than 0");
  }
  if (currentPage < 0) {
    throw new Error("Current page cannot be negative");
  }
  if (currentPage > totalPages) {
    currentPage = totalPages; // Cap at max pages
  }

  const percent = (currentPage / totalPages) * 100;
  return Math.round(percent);
}

export const phoneValidationPattern = new RegExp(
  /^(?:\+?\d{1,3}\s?)?(?:\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}|\d{3}\s?\d{3}\s?\d{3}|\d{3}\s?\d{2}\s?\d{2}\s?\d{2})$/,
);

export const emailValidationPattern = new RegExp(
  /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/,
);
